import Tutorial2 from "./Tutorial2"

export default  Tutorial2;
